import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';

@Pipe({
  name: 'safeResourceUrl',
  standalone: false,
})
export class SafeResourceUrlPipe implements PipeTransform {
  constructor(private readonly _sanitizer: DomSanitizer) {
  }

  public transform(value: string): SafeUrl {
    return this._sanitizer.bypassSecurityTrustResourceUrl(value);
  }
}
